/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BackIcon from '../../../assets/images/leftArrow.svg';
import shared from '../../design-system/Shared';
import Colors from '../../design-system/Colors';
import AccountServices from '../../../modules/account/services/AccountServices';
import AccountActions from './Fragments/AccountActions';

const NavSc = styled.div`
  .row.row-center {
    align-items: center;
    justify-content: center;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .container {
    box-sizing: border-box;
    width: 100%;

    @media (min-width: ${shared.mobileBreakPoint}) {
      max-width: 768px;
      margin: 24px auto;
    }
  }

  .flex1 {
    flex: 1 1;
  }

  .justify-between {
    justify-content: space-between !important;
  }

  .navbar__container {
    box-sizing: border-box;
    width: 100%;
    height: 56px;
    background-color: #fff;
    color: white;
    padding: 16px 0;
    align-items: center;
    display: flex;

    & .container {
      margin: 0 auto;
      padding: 0 16px;

      .navbar__icon-button {
        cursor: pointer;
        position: absolute;
        left: 24px;
        color: ${Colors.white};

        &:hover {
          opacity: 0.7;
        }
      }

      @media (min-width: ${shared.mobileBreakPoint}) {
        padding: 0;
      }
    }

    &.transparent {
      background-image: none;
    }

    & .navbar__icon {
      &-alert {
        margin-left: 32px;
      }

      &-user {
        margin-left: 16px;
      }

      &-return {
        display: flex;
        justify-content: center;
        margin-right: 24px;
      }

      &-circle {
        width: 32px;
        height: 32px;
        opacity: 0.5;
        border: solid 4px #ffffff;
        margin-right: 16px;
        border-radius: 50%;
      }
    }

    @media (min-width: ${shared.mobileBreakPoint}) {
      height: 72px;
      padding: 10px 0;
    }
  }
`;

class Nav extends Component {
  constructor(props) {
    super(props);

    this.onCloseClick = this.onCloseClick.bind(this);
    this.previousPage = this.previousPage.bind(this);
  }

  onCloseClick() {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      this.props.history.push('/');
    }
  }

  previousPage() {
    this.props.onGoBackClick && this.props.onGoBackClick();
  }

  renderBackButtonIfNecessary(shouldRender) {
    return !shouldRender ? (
      <div style={{ width: '48px' }} />
    ) : (
      this.renderButton(<BackIcon />, this.previousPage)
    );
  }

  renderButton(icon, action) {
    return (
      <span className="navbar__icon-button" onClick={action} data-cy="btnVoltar">
        {icon}
      </span>
    );
  }

  render() {
    const { isTransparent, showBackButton, hideActions, navText } = this.props;
    const isAuthenticated = AccountServices.isAuthenticated();
    const displayActions = isAuthenticated && !hideActions;

    return (
      <NavSc>
        <header className={`navbar__container ${isTransparent ? 'transparent' : ''}`}>
          <div className="container">
            <div className="grid gutters">
              <div className="row row-center flex1">
                {this.renderBackButtonIfNecessary(showBackButton)}
                <span className="navbar__text">{navText}</span>
                {displayActions && <AccountActions />}
              </div>
            </div>
          </div>
        </header>
      </NavSc>
    );
  }
}

Nav.defaultProps = {
  isTransparent: false,
  showBackButton: false,
};

Nav.propTypes = {
  isTransparent: PropTypes.bool,
  navText: PropTypes.node,
  onGoBackClick: PropTypes.func,
  showBackButton: PropTypes.bool,
};

export default Nav;
